export const INDIVIDUAL = 'Individual' as const;
export const OFFICE = 'Office' as const;
export const TEAM = 'Team' as const;
export const NETWORK = 'Network' as const;

export const PROFILE_TYPES = [INDIVIDUAL, OFFICE, TEAM, NETWORK] as const;

export type ProfileType = (typeof PROFILE_TYPES)[number];

export const AGENCY_PROFILE_TYPES: ProfileType[] = [OFFICE, TEAM] as const;
